import axiosInstance from "services/AxiosInstance";

export const deleteQuestionnaireRequestService = async ({
  questionnaireRequestId
}: {
  questionnaireRequestId: string;
}): Promise<void> => await axiosInstance.delete(`questionnaire/request/${questionnaireRequestId}`);
